import React, { useState } from 'react';
import * as api from '../services/api'
import Loader from '../../components/Loader';
import styles from './manager.module.css';
import back from '../../assets/icons/back.svg';
import InsertBar from '../../components/InsertBar';
import { Box, Button } from '@mui/material';
import { useNavigate } from "react-router-dom";
import KeyboardBackspaceIcon from '@mui/icons-material/KeyboardBackspace';

function UserTypeAdd() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false)
  const [user_type_name, setUserTypeName] = useState("");

  const handlePrevious = () => {
    
    if (user_type_name.trim()) {
      if (window.confirm(`ยืนยันที่จะยกเลิกการเปลี่ยนแปลง?`)) {
        navigate('/manageUsers');
      }
    } else {
      navigate('/manageUsers');
    }
  };

  const handleUpdate = async () => {
    if (!user_type_name.trim()) {
      alert("กรุณากรอกข้อมูลให้ครบถ้วน");
      return;
    }
    if (window.confirm(`ยืนยันที่จะเพิ่มข้อมูลสิทธิใหม่`)) {
        let data = {
            group_name: user_type_name.trim()
        }
      //Call API to update the database
      //Check if already exists
      setLoading(true);
      const res = await api.newUserType(data);
      setLoading(false);
      if (res['data']['code'] === 200) {
        alert("เพิ่มข้อมูลสำเร็จ");
        // console.log("API Response:", res['data']['message'] );
        navigate('/manageUsers')
        // Reset form fields
        // setUserTypeName("");
      } else {
          //alert(res['data']['message']);
      }
      //navigate('/departmentManager');
    }
  };

  return (
    <>
      <Loader loading={loading} />
      <Box className={`${styles.bodyText} ${styles.inlineFlex}`} onClick={handlePrevious}>
        <img src={back} alt="Previous" className={styles.directIcon} />
        กลับไป จัดการผู้ใช้งาน
      </Box>
      <Box className={styles.head1Text}>เพิ่มสิทธิใหม่</Box>
      <Box sx={{ border: '1.4px solid #478F96', borderRadius: 2, padding: 4, marginTop: '18px' }}>
        <Box className={styles.head2Text}>ชื่อสิทธิ</Box>
        <InsertBar
          currentValue={user_type_name}
          setNewValue={setUserTypeName}
          placeholder="ชื่อสิทธิ"
        />
      </Box>
      <Box sx={{ display: 'flex', justifyContent: 'flex-end', marginTop: 2 , marginRight: 4.3}}>
        <Button
            variant="contained"
            color="primary"
            onClick={handleUpdate}
            sx={{ padding: 1, borderRadius: 1.5 }}
        >
          <p style={{ fontWeight: 600, margin: 0, fontSize: 12, padding: '0 40px' }}>บันทึก</p>
        </Button>
      </Box>
    </>
  );
}

export default UserTypeAdd;
